module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-36x36-6917fad6dc7bc058aa3319284d4024a2.png";